import React from 'react';
import Logo from '../GCLOGO.png';
// import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { status } from '../hooks/AuthProvider';
import DownloadsNavLink from './DownloadsNavLink';
import HeaderCTA from './HeaderCTA';

type DownloadPlatforms = {
    windows?: { url: string };
    macOS_intel?: { url: string };
    macOS_arm?: { url: string };
};

type DownloadData = {
    version: string;
    platforms: DownloadPlatforms;
};

type props = {};

type state = {
    loading: boolean;
    showingSolutions: boolean;
    isScrolled: boolean;
    isAuthenticated: boolean;
    isProductsOpen: boolean;
    downloadData: DownloadData | null;
    downloadLoading: boolean;
};

export default class DownloadsComponent extends React.Component<props, state> {
    constructor(props: props) {
        super(props);
        this.state = {
            loading: false,
            showingSolutions: false,
            isScrolled: false,
            isAuthenticated: false,
            isProductsOpen: false,
            downloadData: null,
            downloadLoading: true,
        };
    }

    async componentDidMount() {
        const handleScroll = () => {
            this.setState({isScrolled: window.scrollY > 10});
        }
        window.addEventListener('scroll', handleScroll);

        try {
            const url = `${process.env.REACT_APP_API_URL || ''}api/v1/system/downloads`;
            const res = await fetch(url);
            if (res.ok) {
                const data = await res.json();
                if (data?.valid) {
                    this.setState({ downloadData: data, downloadLoading: false });
                } else {
                    this.setState({ downloadLoading: false });
                }
            } else {
                this.setState({ downloadLoading: false });
            }
        } catch {
            this.setState({ downloadLoading: false });
        }

        return () => window.removeEventListener('scroll', handleScroll);
    }

    setShowing(showing: boolean) {
        this.setState({showingSolutions: showing});
    }

    render() {
        return (
            <div className="min-h-screen bg-black text-white">
                <header
                    className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                        this.state.isScrolled ? "bg-black/80 backdrop-blur-sm" : "bg-transparent"
                    }`}
                >
                    <div className="container mx-auto px-4">
                        <div className="flex h-16 items-center justify-between">
                            <a href="/" className="flex items-center space-x-2 transition-opacity hover:opacity-80">
                                <img src={Logo} width={'200'} />
                                {/* <svg className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                                />
                                </svg>
                                <span className="text-xl font-bold">GuardedContent</span> */}
                            </a>
    
                            {/* New middle section with dropdowns */}
                            <nav className="hidden md:flex items-center space-x-6">
                                <div className="relative">
                                    <Popover
                                        onMouseEnter={() => this.setShowing(true)}
                                        onMouseLeave={() => this.setShowing(false)}
                                    >
                                        <PopoverButton className="text-white hover:text-red-500 transition-colors flex items-center">Solutions</PopoverButton>
                                        <Transition
                                            enter="transition ease-out duration-200"
                                            enterFrom="opacity-0 translate-y-1"
                                            enterTo="opacity-100 translate-y-0"
                                            leave="transition ease-in duration-150"
                                            leaveFrom="opacity-100 translate-y-0"
                                            leaveTo="opacity-0 translate-y-1"
                                            show={this.state.showingSolutions}
                                        >
                                            <PopoverPanel
                                            anchor="bottom"
                                            className="divide-y divide-white/5 rounded-xl bg-white/5 text-sm/6 [--anchor-gap:var(--spacing-5)] mt-2"
                                            >
                                            <div className="p-3">
                                                <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="./#features">
                                                    <p className="font-semibold text-white">General Media</p>
                                                    <p className="text-white/50">Protect your content using DRM</p>
                                                </a>
                                                {/* <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="#">
                                                    <p className="font-semibold text-white">Music</p>
                                                    <p className="text-white/50">Protect your music using DRM</p>
                                                </a>
                                                <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="#">
                                                    <p className="font-semibold text-white">Corporate Documents</p>
                                                    <p className="text-white/50">Protect your documents using DRM</p>
                                                </a> */}
                                            </div>
                                            {/* <div className="p-3">
                                                <a className="block rounded-lg py-2 px-3 transition hover:bg-white/5" href="#">
                                                <p className="font-semibold text-white">Documentation</p>
                                                <p className="text-white/50">Start integrating products and tools</p>
                                                </a>
                                            </div> */}
                                            </PopoverPanel>
                                        </Transition>
                                    </Popover>
                                    {/* <button
                                        // onClick={() => this.setIsProductsOpen(!this.state.isProductsOpen)}
                                        onClick={() => this.setState({ isProductsOpen: !this.state.isProductsOpen })}
                                        className="text-white hover:text-red-500 transition-colors flex items-center"
                                    >
                                        Products
                                        <svg className="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </button> */}
                                {/* {this.state.isProductsOpen && (
                                    <div className="absolute top-full left-0 mt-2 w-56 bg-gray-900 border border-gray-800 rounded-md shadow-lg">
                                        <a href="#" className="block px-4 py-2 text-white hover:bg-white/10">Content Creation Suite</a>
                                        <a href="#" className="block px-4 py-2 text-white hover:bg-white/10">Analytics Dashboard</a>
                                        <a href="#" className="block px-4 py-2 text-white hover:bg-white/10">Collaboration Tools</a>
                                    </div>
                                )} */}
                                </div>
                                {/* <a href="/pricing" className="text-white hover:text-red-500 transition-colors">Pricing</a> */}
                                <DownloadsNavLink />
                            </nav>
    
                            <nav className="flex items-center gap-4">
                                <HeaderCTA />
                            </nav>
                        </div>
                    </div>
                </header>
            {/* Hero Section */}
            <header className="relative overflow-hidden pt-16">
                <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-purple-500/10 animate-gradient" />
                <div className="container mx-auto px-4 py-24 relative">
                <h1 className="text-5xl md:text-7xl font-bold mb-6 text-center">Downloads</h1>
                <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto text-center mb-8">
                    Get access to our tools, resources, and applications to enhance your content creation experience.
                </p>
                </div>
            </header>
    
            {/* Desktop Apps Section */}
            <section className="py-16 bg-gradient-to-b from-black to-gray-900">
                <div className="container mx-auto px-4">
                <h2 className="text-3xl font-bold mb-12 text-center">Desktop Applications</h2>
                {this.state.downloadLoading ? (
                    <div className="flex justify-center py-16">
                        <div className="w-8 h-8 border-2 border-red-500 border-t-transparent rounded-full animate-spin"></div>
                    </div>
                ) : (
                <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto">
                    {[
                    {
                        platform: "Windows",
                        icon: "fa-windows",
                        version: this.state.downloadData?.version ?? '—',
                        requirements: "Windows 10 or later",
                        url: this.state.downloadData?.platforms?.windows?.url,
                    },
                    {
                        platform: "macOS",
                        icon: "fa-apple",
                        version: this.state.downloadData?.version ?? '—',
                        requirements: "macOS 11.0 or later",
                        url: this.state.downloadData?.platforms?.macOS_arm?.url
                            ?? this.state.downloadData?.platforms?.macOS_intel?.url,
                    },
                    ].map((app, index) => (
                    <div
                        key={index}
                        className="bg-gray-900/50 border border-gray-800 rounded-lg p-8 hover:border-red-500/50 transition-colors"
                    >
                        <div className="flex items-center justify-center mb-6">
                        <i className={`fab ${app.icon} text-red-500 text-5xl`}></i>
                        </div>
                        <h3 className="text-2xl font-bold text-center mb-4">{app.platform}</h3>
                        <div className="space-y-2 mb-6">
                        <div className="flex justify-between">
                            <span className="text-gray-400">Version:</span>
                            <span>{app.version}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-400">Requirements:</span>
                            <span className="text-right">{app.requirements}</span>
                        </div>
                        </div>
                        {app.url ? (
                            <a
                                href={app.url}
                                className="w-full py-3 bg-red-600 hover:bg-red-500 text-white rounded-md transition-colors flex items-center justify-center"
                                download
                            >
                                <i className="fas fa-download mr-2"></i>
                                Download
                            </a>
                        ) : (
                            <button
                                disabled
                                className="w-full py-3 bg-gray-700 text-gray-400 rounded-md cursor-not-allowed flex items-center justify-center"
                            >
                                Unavailable
                            </button>
                        )}
                    </div>
                    ))}
                </div>
                )}
                </div>
            </section>

            {/* Mobile Apps Section */}
            <section className="py-16 bg-gradient-to-b from-gray-900 to-black">
                <div className="container mx-auto px-4">
                <h2 className="text-3xl font-bold mb-12 text-center">Mobile Applications</h2>
    
                <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                    {[
                    {
                        platform: "iOS",
                        icon: "fa-apple",
                        requirements: "iOS 14.0 or later",
                    },
                    {
                        platform: "Android",
                        icon: "fa-android",
                        requirements: "Android 8.0 or later",
                    },
                    ].map((app, index) => (
                    <div
                        key={index}
                        className="bg-gray-900/50 border border-gray-800 rounded-lg p-8 hover:border-red-500/50 transition-colors"
                    >
                        <div className="flex items-center justify-center mb-6">
                        <i className={`fab ${app.icon} text-red-500 text-5xl`}></i>
                        </div>
                        <h3 className="text-2xl font-bold text-center mb-4">{app.platform}</h3>
                        <div className="space-y-2 mb-6">
                        <div className="flex justify-between">
                            <span className="text-gray-400">Requirements:</span>
                            <span className="text-right">{app.requirements}</span>
                        </div>
                        </div>
                        <button
                            disabled
                            className="w-full py-3 bg-gray-800 text-gray-500 rounded-md cursor-not-allowed flex items-center justify-center gap-2"
                        >
                            <i className="fas fa-clock"></i>
                            Coming Soon
                        </button>
                    </div>
                    ))}
                </div>
                </div>
            </section>
    
            {/* Plugins Section */}
            {/* <section className="py-16 bg-gradient-to-b from-black to-gray-900">
                <div className="container mx-auto px-4">
                <h2 className="text-3xl font-bold mb-12 text-center">Plugins & Extensions</h2>
    
                <div className="grid md:grid-cols-4 gap-6">
                    {[
                    {
                        name: "Adobe Premiere Pro",
                        icon: "fa-adobe",
                        description: "Export and import content directly from Adobe Premiere Pro",
                    },
                    {
                        name: "Final Cut Pro",
                        icon: "fa-apple",
                        description: "Seamlessly integrate with Final Cut Pro for video editing",
                    },
                    {
                        name: "Photoshop",
                        icon: "fa-adobe",
                        description: "Edit and enhance images with our Photoshop plugin",
                    },
                    {
                        name: "After Effects",
                        icon: "fa-adobe",
                        description: "Create stunning visual effects with our After Effects integration",
                    },
                    {
                        name: "Chrome Extension",
                        icon: "fa-chrome",
                        description: "Capture and save content directly from your browser",
                    },
                    {
                        name: "Firefox Add-on",
                        icon: "fa-firefox",
                        description: "Capture and save content directly from Firefox",
                    },
                    ].map((plugin, index) => (
                    <div
                        key={index}
                        className="p-4 bg-gray-900/50 border border-gray-800 rounded-lg hover:border-red-500/50 transition-colors flex flex-col h-full"
                    >
                        <div className="flex items-center justify-center mb-4">
                        <i className={`fab ${plugin.icon} text-red-500 text-3xl`}></i>
                        </div>
                        <h3 className="text-lg font-bold text-center mb-2">{plugin.name}</h3>
                        <p className="text-sm text-gray-400 text-center mb-4">{plugin.description}</p>
                        <div className="mt-auto">
                            <button className="w-full py-2 bg-gray-800 hover:bg-gray-700 text-white rounded-md transition-colors text-sm">
                                Download
                            </button>
                        </div>
                    </div>
                    ))}
                </div>
                </div>
            </section> */}
    
            {/* CTA Section */}
            {/* <section className="py-16 relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-purple-500/10 animate-gradient" />
                <div className="container mx-auto px-4 relative">
                <div className="max-w-3xl mx-auto text-center">
                    <h2 className="text-3xl font-bold mb-6">Need Something Custom?</h2>
                    <p className="text-xl text-gray-400 mb-8">
                    Our team can help you with custom solutions tailored to your specific needs.
                    </p>
                    <button className="px-6 py-3 bg-red-500 hover:bg-red-600 text-white rounded-md transition-colors inline-flex items-center">
                    Contact Our Team <i className="fas fa-arrow-right ml-2"></i>
                    </button>
                </div>
                </div>
            </section> */}
    
            {/* Footer */}
            <footer className="border-t border-gray-800 py-12">
                <div className="container mx-auto px-4">
                <div className="grid md:grid-cols-4 gap-8">
                    <div>
                    <h3 className="font-bold text-xl mb-4">GuardedContent</h3>
                    <p className="text-gray-400">The future of content creation.</p>
                    </div>
                    {[
                    {
                        title: "Product",
                        links: ["Features", "Pricing", "Security", "Roadmap"],
                    },
                    {
                        title: "Resources",
                        links: ["Blog", "Documentation", "Guides", "Help Center"],
                    },
                    {
                        title: "Company",
                        links: ["About", "Careers", "Contact", "Press"],
                    },
                    ].map((column, index) => (
                    <div key={index}>
                        <h3 className="font-bold mb-4">{column.title}</h3>
                        <ul className="space-y-2">
                        {column.links.map((link, linkIndex) => (
                            <li key={linkIndex}>
                            <a href="#" className="text-gray-400 hover:text-white transition-colors">
                                {link}
                            </a>
                            </li>
                        ))}
                        </ul>
                    </div>
                    ))}
                </div>
                <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
                    <p>&copy; {new Date().getFullYear()} GuardedContent. All rights reserved.</p>
                </div>
                </div>
            </footer>
            </div>
        )
    }
}